import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { Header } from "@/components/site/Header";
import { Footer, WhatsAppFab } from "@/components/site/Footer";
import { RequireAuth, Page } from "@/components/site/Common";
import { AppDownload } from "@/components/site/AppDownload";
import Home from "@/pages/Home";
import Pros from "@/pages/Pros";
import ProDetail from "@/pages/ProDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Forgot from "@/pages/Forgot";
import Panel from "@/pages/Panel";
import NewJob from "@/pages/NewJob";
import JobDetail from "@/pages/JobDetail";
import Invoices from "@/pages/Invoices";
import Support from "@/pages/Support";
import Agenda from "@/pages/Agenda";
import { Academy, Course } from "@/pages/Academy";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return (
    <div className="flex min-h-screen flex-col bg-slate-50 font-body text-slate-900">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
};

const auth = (el, role) => <RequireAuth role={role}>{el}</RequireAuth>;

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/profesionales" element={<Pros />} />
          <Route path="/profesionales/:id" element={<ProDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/recuperar" element={<Forgot />} />
          <Route path="/soporte" element={<Support />} />
          <Route path="/descargar-app" element={<Page><AppDownload /></Page>} />
          <Route path="/panel" element={auth(<Panel />)} />
          <Route path="/cliente" element={<Navigate to="/panel" replace />} />
          <Route path="/profesional" element={<Navigate to="/panel" replace />} />
          <Route path="/crear-solicitud" element={auth(<NewJob />, "cliente")} />
          <Route path="/trabajos/:id" element={auth(<JobDetail />)} />
          <Route path="/agenda" element={auth(<Agenda />)} />
          <Route path="/facturas" element={auth(<Invoices />)} />
          <Route path="/formacion" element={auth(<Academy />, "profesional")} />
          <Route path="/formacion/:id" element={auth(<Course />, "profesional")} />
          <Route path="/payment/success" element={auth(<PaymentSuccess />)} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
